import { get } from 'lodash';

const getPostCounters = (state: any, postId: any) => state.postCounters[postId];

export const getViewCount = (state: any, postId: any) =>
  get(getPostCounters(state, postId), 'viewCount', 0);
export const getCommentCount = (state: any, postId: any) =>
  get(getPostCounters(state, postId), 'totalComments', 0);
